import { render, staticRenderFns } from "./FormSetStandBy.vue?vue&type=template&id=6c1efc8a"
import script from "./FormSetStandBy.vue?vue&type=script&lang=js"
export * from "./FormSetStandBy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports